import { useCallback } from "react";
import { useHttpAdapter } from "./useHttpAdapter";
import { GenerateLeadsResponse, LeadsApiResponse } from "../types/leads";

const DEFAULT_PAGE_SIZE = 15;

export const useLeadsApi = () => {
  const { get, post } = useHttpAdapter();

  const getLeads = useCallback(
    async (brandId: string, page: number, perPage: number = DEFAULT_PAGE_SIZE) => {
      try {
        const response = await get<LeadsApiResponse>(
          `/brand/${brandId}/leads?page=${page}&per_page=${perPage}`
        );

        if (response.status === 200) {
          return response.data;
        }

        return null;
      } catch {
        return null;
      }
    },
    [get]
  );

  const generateLeads = useCallback(
    async (brandId: string) => {
      try {
        const response = await post<GenerateLeadsResponse>(
          `/brand/${brandId}/leads/generate`
        );

        if (response.status === 200) {
          return response.data;
        }

        return null;
      } catch {
        return null;
      }
    },
    [post]
  );

  return { getLeads, generateLeads };
};
